const LOCALE_KEY = "app_locale";

const MESSAGES = {
  "vi-VN": {
    subtitleContinue: "Đăng nhập để tiếp tục",
    username: "Tên đăng nhập",
    password: "Mật khẩu",
    submit: "Đăng nhập",
    submitting: "Đang đăng nhập…",
    showPassword: "Hiện mật khẩu",
    hidePassword: "Ẩn mật khẩu",
    copyright: "All rights reserved.",
    ssoLogin: "Đăng nhập qua SSO",
    ssoRedirecting: "Đang chuyển…",
    ssoContinue: "Tiếp tục",
    ssoContinueWith: "Tiếp tục với {name}",
    orDivider: "hoặc",
  },
  "en-US": {
    subtitleContinue: "Sign in to continue",
    username: "Username",
    password: "Password",
    submit: "Sign in",
    submitting: "Signing in…",
    showPassword: "Show password",
    hidePassword: "Hide password",
    copyright: "All rights reserved.",
    ssoLogin: "Sign in with SSO",
    ssoRedirecting: "Redirecting…",
    ssoContinue: "Continue",
    ssoContinueWith: "Continue as {name}",
    orDivider: "or",
  },
};

export function getLoginLocale() {
  if (typeof window === "undefined") return "vi-VN";
  const stored = localStorage.getItem(LOCALE_KEY);
  if (stored && MESSAGES[stored]) return stored;
  return "vi-VN";
}

export function setLoginLocale(locale) {
  if (typeof window !== "undefined" && MESSAGES[locale]) {
    localStorage.setItem(LOCALE_KEY, locale);
  }
}

export function loginT(locale, key) {
  const loc = MESSAGES[locale] ? locale : "vi-VN";
  return MESSAGES[loc][key] || MESSAGES["vi-VN"][key] || key;
}
